<template>
  <NInput
    class="c-input-placeholder"
    readonly
    :style="{
      backgroundColor: themeVars.primary6,
      '--n-text-color': themeVars.primary,
    }"
    type="text"
    :value="placeholder"
    @click="emit('click')"
  >
    <template #suffix>
      <slot name="suffix" />
    </template>
  </NInput>
</template>

<script setup lang="ts">
import { NInput } from 'naive-ui'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import useThemeVars from '@lib/composables/useThemeVars'

const props = defineProps<{
  value?: string
}>()

const emit = defineEmits<{
  click: []
}>()

const { t } = useI18n()
const themeVars = useThemeVars()
const placeholder = computed(() => props.value || t('canvasUI.CInputPlaceholder.keepAsIs'))
</script>

<style scoped>
.c-input-placeholder :deep(.n-input__input-el) {
  letter-spacing: 1.25px;
}
</style>
